import React, { useState, useContext, Fragment } from 'react';
import { PrimaryButton, Rating, IconButton, ActionButton, TextField } from '@fluentui/react';
import htmr from 'htmr';

function StarRating(props) {
    const [size, setSize] = useState('5');
    const [type, setType] = useState(props.data.ratingType);
    const [currentRating, setCurrentRating] = React.useState(props.value);

    const typeOptions = [
        { key: 'StarburstSolid', text: 'StarburstSolid', icon: 'StarburstSolid', unselectedIcon: 'Starburst' },
        { key: 'RadioBtnOff', text: 'RadioBtnOff', icon: 'RadioBtnOn', unselectedIcon: 'RadioBtnOff' },
        { key: 'FavoriteStar', text: 'FavoriteStar', icon: 'FavoriteStarFill', unselectedIcon: 'FavoriteStar' },
    ];

    return (
        <div className="flexcolumn displayflex flex1 quiz-container">
            <div style={{ fontSize: 16 }}>
                {htmr(props.data.question)}
            </div>
            <div className="displayflex flex1 width100" style={{ maxWidth: 600, marginTop: props.view ? 10 : 20 }}>
                <form className="default-form width100">
                    <div className={`form-group justifycenter flex-column width100 rating-size${size}`}>
                       
                        <div className=" displayflex justifycenter width100">
                            <Rating
                                rating={currentRating}
                                onChange={(e, n) => { setCurrentRating(n); props.setValue(n ? n.toString() : n) } }
                                max={props.data.ratingSize}
                                icon={typeOptions.filter(x => x.key == type).map(x => x.icon)[0]}
                                unselectedIcon={typeOptions.filter(x => x.key == type).map(x => x.unselectedIcon)[0]}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default StarRating;